import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

const navItems = [
     { to: '/admin', label: 'Dashboard', end: true },
     { to: '/admin/bookings', label: 'Bookings' },
     { to: '/admin/inventory', label: 'Inventory' },
     { to: '/admin/calendar', label: 'Block Dates' },
     { to: '/admin/abandoned', label: 'Abandoned' },
     { to: '/admin/customers', label: 'Customers' },
     { to: '/admin/inquiries', label: 'Inquiries' },
     { to: '/admin/sales', label: 'Sales' },
     { to: '/admin/expenses', label: 'Expenses' },
     { to: '/admin/reports', label: 'Reports' },
     { to: '/admin/heatmap', label: 'Heatmap' },
     { to: '/admin/email-templates', label: 'Emails' },
];

export default function AdminLayout() {
     const { signOut } = useAuth();

     return (
          <div className='min-h-screen bg-gray-50'>
               {/* Top Bar */}
               <header className='bg-white border-b border-gray-200'>
                    <div className='max-w-7xl mx-auto px-4 py-3 flex items-center justify-between'>
                         <div className='flex items-center gap-6'>
                              <a href='/' className='text-yellow font-bold text-lg'>
                                   Ripout Rentals
                              </a>
                              <span className='text-darker/30 text-sm'>Admin</span>
                         </div>
                         <div className='flex items-center gap-4'>
                              <a
                                   href='/'
                                   className='text-darker/40 text-sm hover:text-darker duration-300'
                              >
                                   View Site
                              </a>
                              <button
                                   onClick={signOut}
                                   className='text-darker/40 text-sm hover:text-red-400 duration-300'
                              >
                                   Sign Out
                              </button>
                         </div>
                    </div>
               </header>

               <div className='max-w-7xl mx-auto flex'>
                    {/* Sidebar */}
                    <nav className='w-56 min-h-[calc(100vh-56px)] bg-white border-r border-gray-200 p-4 hidden tablet:block'>
                         <ul className='space-y-1'>
                              {navItems.map((item) => (
                                   <li key={item.to}>
                                        <NavLink
                                             to={item.to}
                                             end={item.end}
                                             className={({ isActive }) =>
                                                  `block px-3 py-2 rounded-lg text-sm duration-300 ${
                                                       isActive
                                                            ? 'bg-yellow/10 text-yellow'
                                                            : 'text-darker/60 hover:text-darker hover:bg-gray-100'
                                                  }`
                                             }
                                        >
                                             {item.label}
                                        </NavLink>
                                   </li>
                              ))}
                         </ul>
                    </nav>

                    {/* Mobile Nav */}
                    <div className='tablet:hidden w-full border-b border-gray-200 bg-white px-4 py-2 flex gap-2 overflow-x-auto'>
                         {navItems.map((item) => (
                              <NavLink
                                   key={item.to}
                                   to={item.to}
                                   end={item.end}
                                   className={({ isActive }) =>
                                        `whitespace-nowrap px-3 py-1.5 rounded-lg text-sm duration-300 ${
                                             isActive
                                                  ? 'bg-yellow/10 text-yellow'
                                                  : 'text-darker/60 hover:text-darker'
                                        }`
                                   }
                              >
                                   {item.label}
                              </NavLink>
                         ))}
                    </div>

                    {/* Content */}
                    <main className='flex-1 p-6'>
                         <Outlet />
                    </main>
               </div>
          </div>
     );
}
